export enum IncomingWiresColumns {
	id = "Id",
	org = "Org",
	bank = "Bank",
	accountId = "Account",
	customer = "Customer",
	amount = "Amount",
	status = "Status",
	businessFunctionCode = "Business Function Code",
	isMonetary = "Monetary",
	cycleDate = "Cycle Date",
	createdAt = "Created At",
}

export type AllowedIncomingWiresColumns =
	| IncomingWiresColumns.id
	| IncomingWiresColumns.org
	| IncomingWiresColumns.bank
	| IncomingWiresColumns.accountId
	| IncomingWiresColumns.customer
	| IncomingWiresColumns.amount
	| IncomingWiresColumns.status
	| IncomingWiresColumns.businessFunctionCode
	| IncomingWiresColumns.isMonetary
	| IncomingWiresColumns.cycleDate
	| IncomingWiresColumns.createdAt
